/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalAccess from './hospital-access';
import HospitalAccessDetail from './hospital-access-detail';
import HospitalAccessUpdate from './hospital-access-update';
import HospitalAccessDeleteDialog from './hospital-access-delete-dialog';

const HospitalAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalAccess />} />
    <Route path="new" element={<HospitalAccessUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalAccessDetail />} />
      <Route path="edit" element={<HospitalAccessUpdate />} />
      <Route path="delete" element={<HospitalAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalAccessRoutes;
